import { NgModule } from '@angular/core';
import { MePaymentComponent } from './me-payment.component';
import { BaseModule } from '../../shared/base.module';
import { StoryBlokLinkModule } from '../../shared/storyblok/link/link.module';
import { MePaymentRoutesModule } from './me-payment.routes';
import { MePaymentFormComponent } from './payment-form/payment-form.component';
import { MePaymentCouponCardComponent } from './coupon-card/coupon-card.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MePaymentLoadingComponent } from './payment-loading/payment-loading.component';
import { MePaymentSuccessComponent } from './payment-success/payment-success.component';
import { MePaymentErrorComponent } from './payment-error/payment-error.component';
import { MePackageModule } from '../packages/me-package.module';
import { MePaymentVerifyComponent } from './payment-verify/payment-verify.component';

@NgModule({
    imports: [
        BaseModule,
        MatSlideToggleModule,
        MePaymentRoutesModule,
        MePackageModule,
        StoryBlokLinkModule
    ],
    declarations: [
        MePaymentFormComponent,
        MePaymentLoadingComponent,
        MePaymentSuccessComponent,
        MePaymentErrorComponent,
        MePaymentCouponCardComponent,
        MePaymentVerifyComponent,
        MePaymentComponent
    ],
    exports: [
        MePaymentComponent
    ]
})
export class MePaymentModule { }
